import { useMemo, useState, type ReactNode } from "react";

import type { LoadContextInt } from "@/types/contexts";
import LoadContext from "@/contexts/LoadContext";

type Props = {
  children: string | ReactNode;
};

const LoadContextProvider = ({ children }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const openLoading = (msg: string) => {
    setMessage(msg);
    setIsLoading(true);
  };

  const closeLoading = () => {
    setIsLoading(false);
    setMessage("");
  };

  const value = useMemo<LoadContextInt>(
    () => ({
      isLoading,
      setIsLoading,
      message,
      openLoading,
      closeLoading,
      setMessage
    }),
    [isLoading, message]
  );

  return <LoadContext.Provider value={value}>{children}</LoadContext.Provider>;
};

export default LoadContextProvider;
